export const tmpData = [0, 1, 0, 2, 4, 3];
